import React, { useState, useEffect } from 'react';
import './Navigation.css'; // Your CSS file for styling
import { Link } from 'react-router-dom';

const Navigation = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const checkWindowWidth = () => {
        setIsMobile(window.innerWidth <= 768); // Adjust this value as needed for your breakpoint
    };

    useEffect(() => {
        checkWindowWidth();
        window.addEventListener('resize', checkWindowWidth);

        return () => {
            window.removeEventListener('resize', checkWindowWidth);
        };
    }, []);

    return (
        <nav className="navigation">
            {isMobile ? (
                <div className="mobile-menu">
                    <button onClick={handleToggle} className="menu-icon">
                        ☰
                    </button>
                    {isOpen && (
                        <ul className="menu-items">
                            {/* Your mobile menu items */}
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/chi-siamo">Chi Siamo</Link></li>
                            <li><Link to="/servizi">Servizi</Link></li>
                            <li><Link to="/contatti">Contatti</Link></li>
                            {/* Add more menu items as needed */}
                        </ul>
                    )}
                </div>
            ) : (
                <ul className="menu-items">
                    {/* Your regular menu items */}
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/chi-siamo">Chi Siamo</Link></li>
                    <li><Link to="/servizi">Servizi</Link></li>
                    <li><Link to="/contatti">Contatti</Link></li>
                    {/* Add more menu items as needed */}
                </ul>
            )}
        </nav>
    );
};

export default Navigation;